<template>
    <div class="customer-invoices_total">
        <div class="row">
            <div :class="{'col-lg-9': !selectedBracket, 'col-lg-3': selectedBracket}">
                <div class="placeholder fit-content">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="customers.customerGroups" />
                        Hvordan er kunderne fordelt på omsætning?
                    </div>
                    <div class="placeholder">
                        
                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            @on-row-click="handleRowClick"
                            :row-style-class="selectedRowClass"
                            v-if="!loading && rows.length > 0"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'">
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'bracket'">
                                    {{ props.row.bracket }} kr.
                                </div>
                                <div v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>
            <div :class="{'col-lg-3': !selectedBracket, 'col-lg-9': selectedBracket}">
                <div class="info" v-if="!selectedBracket">
                    Vælg et interval for at se en liste over alle kunder i intervallet.
                </div>
                
                <div v-if="selectedBracket">
                    <div style="margin-bottom:5px;">
                        <a href="javascript:void(0)" @click="selectedBracket = null" style="text-decoration:none;color:#172b43;font-weight:600;">
                            <i class="far fa-times" /> Luk
                        </a>
                    </div>
                </div>

                <customer-grouped-single :customers="groupedCustomers[selectedBracket]" :name="selectedBracket" v-if="selectedBracket" />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: [
        'title'
    ],
    data () {
        return {
            groupBy: 'invoices_total', // can be 'invoices_total', 'coverage' or 'coverage_percent',
            selectedBracket: '',
            selectedProjectType: null,
            selectedRow: null,
            loading: false,
            columns: [
                { label: 'Omsætning pr. kunde', field: 'bracket', type: 'string', sortable: false },
                { label: 'Kunder', field: 'count', type: 'number' },
                { label: 'Omsætning i alt', field: 'invoices_total', width: '10%', type: 'number' },
                { label: 'DB', field: 'coverage', width: '10%', type: 'number' },
                { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }
                // { label: '', field: 'action', width: '5%', type: 'string', filterable: false }
            ],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
                /* initialSortBy: {
                    field: 'coverage_percent',
                    type: 'desc'
                } */
            },
            styleClass: 'vgt-table'
        }
    },
    computed: {
        customerRevenueRows () {
            return this.$store.state.customerRevenueRows
        },
        groupedCustomers () {
            return _.groupBy(this.customerRevenueRows, (customer) => {
                if (customer.invoices_total <= 2000) {
                    return '0 - 2.000'
                } else if (customer.invoices_total <= 5000) {
                    return '2.001 - 5.000'
                } else if (customer.invoices_total <= 10000) {
                    return '5.001 - 10.000'
                } else if (customer.invoices_total <= 20000) {
                    return '10.001 - 20.000'
                } else if (customer.invoices_total <= 50000) {
                    return '20.001 - 50.000'
                } else if (customer.invoices_total <= 100000) {
                    return '50.001 - 100.000'
                } else {
                    return 'over 100.000'
                }
            })
        }
    },
    watch: {
        customerRevenueRows: function () {
            if (this.customerRevenueRows.length) {
                this.calculateData()
            }
        }
    },
    methods: {
        selectedRowClass (row) {
            if (row.bracket === this.selectedBracket) {
                return 'selected'
            }
        },
        handleRowClick (params) {
            this.selectedBracket = params.row.bracket
        },
        openExternalLink (id) {
            alert('Åbn sagsnummer ' + id + ' i Ordrestyring nu')
            // window.open('LINKHERE', '_blank')
        },
        calculateData () {
            this.rows = []
            Object.keys(this.groupedCustomers).forEach(customerBracket => {
                // Laver array med alle invoices_total
                let invoicesTotalArray = this.groupedCustomers[customerBracket].map(customer => {
                    return Math.round(customer.invoices_total)
                })
                // Summerer alle invoices_total
                let summedInvoicesTotal = _.reduce(invoicesTotalArray, (sum, invoicesTotal) => {
                    return sum + invoicesTotal
                })
                // Laver array med alle DB
                let coverageArray = this.groupedCustomers[customerBracket].map(customer => {
                    return Math.round(customer.coverage)
                })
                // Summerer alle DB
                let summedCoverage = _.reduce(coverageArray, (sum, coverage) => {
                    return sum + coverage
                })
                // Summerer alle timelog hours
                let timelogHoursArray = this.groupedCustomers[customerBracket].map(customer => {
                    return customer.timelog_hours_total
                })
                let summedTimelogHours = _.reduce(timelogHoursArray, (sum, timelogHoursTotal) => {
                    return sum + timelogHoursTotal
                })
                // Laver array med alle DG og DB/time, der ikke er 0
                // let coveragePercentArray = []
                // let coveragePerHourArray = []
                /* this.groupedCustomers[customerBracket].forEach(customer => {
                    if (customer.coverage_percent) {
                        coveragePercentArray.push(Math.round(customer.coverage_percent))
                    }
                    if (customer.coverage_per_hour) {
                        coveragePerHourArray.push(customer.coverage_per_hour)
                    }
                }) */
                // Beregner gennemsnit af DG- og DB/time-arrays
                // let averageCoveragePercent = _.mean(coveragePercentArray)
                // let averageCoveragePerHour = _.mean(coveragePerHourArray)
                // Bygger object med alle 3 værdier
                let item = {
                    bracket: customerBracket,
                    count: this.groupedCustomers[customerBracket].length,
                    invoices_total: summedInvoicesTotal,
                    coverage: summedCoverage,
                    // coverage_percent_avg: Math.round(averageCoveragePercent),
                    // coverage_percent: Math.round((summedCoverage / summedInvoicesTotal) * 100),
                    // coverage_per_hour: Math.round(averageCoveragePerHour)
                    coverage_percent: summedInvoicesTotal > 0 ? (summedCoverage / summedInvoicesTotal) * 100 : 0,
                    coverage_per_hour: summedTimelogHours > 0 ? (summedCoverage / summedTimelogHours) : 0,
                    timelog_hours_total: summedTimelogHours
                }
                this.rows.push(item)
            })
            this.rows.sort((a, b) => {
                let aSubstring = parseInt(a.bracket.substring(a.bracket.lastIndexOf(' ') + 1, a.bracket.lastIndexOf('.')))
                let bSubstring = parseInt(b.bracket.substring(b.bracket.lastIndexOf(' ') + 1, b.bracket.lastIndexOf('.')))
                return aSubstring > bSubstring ? 1 : -1
            })
            this.$emit('finishedLoading', this.rows.length)
        }
    },
    components: {
        'customer-grouped-single': require('./customerGroupedSingle.vue')
    }
}
</script>



// WEBPACK FOOTER //
// customerRevenueGrouped.vue?3a031d42